/* Base translations · Estimates worksheet — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): est. */
export const I18N_BASE_ESTIMATES = {
  en: {
    // Batch C · Round C2 · W8 — Estimates worksheet — EN
    est: {
      title: "Estimate worksheet",
      estimateName: "Estimate", fsHead: "FS head",
      linkedRisk: "Linked risk",
      linkedRiskPh: "Enter risk id (register unavailable)",
      linkedRiskEmpty: "No risks in the register yet",
      significant: "Significant",
      link207a: "Link to 207(a)",
      open207a: "Open 207(a) — Accounting Estimates",
      link207aNotePh: "Note (optional)",
      managementPoint: "Management's point estimate",
      approach: {
        title: "Approach — at least one required",
        a: "Events up to the date of the auditor's report",
        aNote: "Note",
        b: "Test how management made the estimate",
        b_methods: "Methods",
        b_assumptions: "Significant assumptions",
        b_data: "Data",
        description: "Description",
        evaluation: "Evaluation",
        evidence: "Evidence link",
        c: "Auditor's point estimate or range",
        point: "Point estimate",
        low: "Low", high: "High", basis: "Basis",
      },
      difference: "Difference vs point / nearest end of range",
      sendToMisstatements: "Send to misstatements (Judgmental)",
      sentToMsOk: "Sent to misstatements (Judgmental).",
      priorPeriod: "Prior-period outcome (PY estimate vs actual)",
      priorPeriodEstimate: "PY estimate",
      priorPeriodActual: "Actual",
      priorPeriodNote: "Note",
      priorYearReadOnly: "Prior year (FY{fy}) — read-only, for the retrospective review of prior-year estimates (ISA 540 (Revised) para 14)",
      priorYearName: "Estimate",
      priorYearPoint: "Management's point estimate",
      priorYearConclusion: "Conclusion",
      biasIndicators: "Indicators of possible management bias",
      biasYes: "Yes", biasNo: "No", biasNote: "Note (required if Yes)",
      disclosureUncertainty: "Disclosure of estimation uncertainty evaluated",
      conclusion: "Conclusion",
      conclusionReasonable: "Reasonable",
      conclusionMisstated: "Misstated",
      preparer: "Preparer", reviewer: "Reviewer",
      markComplete: "Mark complete",
      addWorksheet: "Add estimate worksheet",
      estimatePlaceholder: "e.g. ECL, Warranty provision, ESB, NRV, Impairment",
      reasons: {
        approach_required: "Pick at least one approach (a / b / c).",
        conclusion_missing: "Conclusion is required.",
        bias_note_required: "Bias note is required when indicators are present.",
        b_block_evaluation_missing: "Approach (b): every block (Methods, Significant assumptions, Data) needs an evaluation.",
        c_range_or_point_missing: "Approach (c): enter the auditor's point estimate, or both Low and High.",
        disclosure_uncertainty_undecided: "Set Disclosure of estimation uncertainty to Yes or No.",
        disclosure_no_needs_note: "A No on disclosure needs a note.",
        preparer_missing: "Preparer sign-off is required.",
        reviewer_missing: "Reviewer sign-off is required.",
      },
    },
  },
  ar: {
    // Batch C · Round C2 · W8 — Estimates worksheet — AR
    est: {
      title: "ورقة عمل التقديرات",
      estimateName: "التقدير", fsHead: "بند القوائم المالية",
      linkedRisk: "الخطر المرتبط",
      linkedRiskPh: "أدخل معرف الخطر (سجل الأخطار غير متاح)",
      linkedRiskEmpty: "لا توجد أخطار مسجّلة بعد",
      significant: "هام",
      link207a: "رابط 207(a)",
      open207a: "فتح 207(a) — التقديرات المحاسبية",
      link207aNotePh: "ملاحظة (اختياري)",
      managementPoint: "التقدير النقطي للإدارة",
      approach: {
        title: "الأسلوب — مطلوب أسلوب واحد على الأقل",
        a: "أحداث حتى تاريخ تقرير المراجع",
        aNote: "الملاحظة",
        b: "اختبار كيفية إعداد الإدارة للتقدير",
        b_methods: "الأساليب",
        b_assumptions: "الافتراضات الهامة",
        b_data: "البيانات",
        description: "الوصف",
        evaluation: "التقييم",
        evidence: "رابط الدليل",
        c: "تقدير نقطي أو نطاق للمراجع",
        point: "التقدير النقطي",
        low: "الحد الأدنى", high: "الحد الأعلى", basis: "الأساس",
      },
      difference: "الفرق مقارنةً بالنقطة / أقرب طرف من النطاق",
      sendToMisstatements: "إرسال إلى التحريفات (اجتهادي)",
      sentToMsOk: "تم الإرسال إلى التحريفات (اجتهادي).",
      priorPeriod: "نتيجة الفترة السابقة (تقدير الفترة السابقة مقابل الفعلي)",
      priorPeriodEstimate: "تقدير الفترة السابقة",
      priorPeriodActual: "الفعلي",
      priorPeriodNote: "الملاحظة",
      priorYearReadOnly: "السنة السابقة (السنة المالية {fy}) — للاطلاع فقط، للمراجعة بأثر رجعي لتقديرات السنة السابقة (معيار التدقيق الدولي 540 (المعدَّل) الفقرة 14)",
      priorYearName: "التقدير",
      priorYearPoint: "تقدير الإدارة",
      priorYearConclusion: "الاستنتاج",
      biasIndicators: "مؤشرات التحيز المحتمل للإدارة",
      biasYes: "نعم", biasNo: "لا", biasNote: "ملاحظة (مطلوبة عند «نعم»)",
      disclosureUncertainty: "تم تقييم الإفصاح عن عدم اليقين في التقدير",
      conclusion: "الاستنتاج",
      conclusionReasonable: "معقول",
      conclusionMisstated: "محرَّف",
      preparer: "المُعِد", reviewer: "المُراجِع",
      markComplete: "تعليم مكتمل",
      addWorksheet: "إضافة ورقة تقدير",
      estimatePlaceholder: "مثال: خسائر ائتمانية متوقعة، مخصص ضمان، مكافأة نهاية الخدمة، صافي القيمة القابلة للتحقق، هبوط قيمة",
      reasons: {
        approach_required: "اختر أسلوبًا واحدًا على الأقل (أ / ب / ج).",
        conclusion_missing: "الاستنتاج مطلوب.",
        bias_note_required: "الملاحظة مطلوبة عند وجود مؤشرات التحيز.",
        b_block_evaluation_missing: "الأسلوب (ب): كل قسم (الأساليب، الافتراضات الهامة، البيانات) يحتاج إلى تقييم.",
        c_range_or_point_missing: "الأسلوب (ج): أدخل التقدير النقطي للمراجع، أو كلاً من الحد الأدنى والأعلى.",
        disclosure_uncertainty_undecided: "اضبط الإفصاح عن عدم اليقين في التقدير على نعم أو لا.",
        disclosure_no_needs_note: "الجواب «لا» على الإفصاح يحتاج إلى ملاحظة.",
        preparer_missing: "توقيع المُعِد مطلوب.",
        reviewer_missing: "توقيع المُراجِع مطلوب.",
      },
    },
  },
};

export default I18N_BASE_ESTIMATES;
